<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="15" r="5" :fill="`url(#${componentId}_paint0_linear_3136_637)`" />
    <foreignObject
      x="0"
      y="2"
      width="22.8481"
      height="22.8481"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(1.5px); clip-path: url(#${componentId}_bgblur_0_3136_637_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <g :filter="`url(#${componentId}_filter0_i_3136_637)`" data-figma-bg-blur-radius="3">
      <path
        d="M7.57934 17.2688C5.30202 14.9915 3.95412 12.6737 3.2517 10.8835C2.56813 9.14132 3.35431 7.35169 4.67765 6.02834L5.26661 5.43939C5.92203 4.78396 7.00912 4.87393 7.54787 5.62819L9.43146 8.26521C9.80399 8.78676 9.80399 9.48738 9.43146 10.0089L8.87841 10.7832C8.50649 11.3039 8.44839 11.9553 8.81458 12.48C9.25541 13.1117 9.88888 13.9215 10.4078 14.4404C10.9267 14.9593 11.7364 15.5927 12.3681 16.0336C12.8928 16.3997 13.5443 16.3416 14.0649 15.9697L14.8392 15.4167C15.3608 15.0441 16.0614 15.0441 16.5829 15.4167L19.2199 17.3003C19.9742 17.839 20.0642 18.9261 19.4087 19.5815L18.8198 20.1705C17.4964 21.4938 15.7068 22.28 13.9646 21.5964C12.1744 20.894 9.85666 19.5461 7.57934 17.2688Z"
        fill="#F1F1F1"
        fill-opacity="0.05"
      />
      <path
        d="M7.57934 17.2688C5.30202 14.9915 3.95412 12.6737 3.2517 10.8835C2.56813 9.14132 3.35431 7.35169 4.67765 6.02834L5.26661 5.43939C5.92203 4.78396 7.00912 4.87393 7.54787 5.62819L9.43146 8.26521C9.80399 8.78676 9.80399 9.48738 9.43146 10.0089L8.87841 10.7832C8.50649 11.3039 8.44839 11.9553 8.81458 12.48C9.25541 13.1117 9.88888 13.9215 10.4078 14.4404C10.9267 14.9593 11.7364 15.5927 12.3681 16.0336C12.8928 16.3997 13.5443 16.3416 14.0649 15.9697L14.8392 15.4167C15.3608 15.0441 16.0614 15.0441 16.5829 15.4167L19.2199 17.3003C19.9742 17.839 20.0642 18.9261 19.4087 19.5815L18.8198 20.1705C17.4964 21.4938 15.7068 22.28 13.9646 21.5964C12.1744 20.894 9.85666 19.5461 7.57934 17.2688Z"
        :fill="`url(#${componentId}_paint1_linear_3136_637)`"
        fill-opacity="0.4"
      />
      <path
        d="M5.33691 5.50977C5.91036 4.93632 6.83815 4.97463 7.36621 5.56152L7.4668 5.68652L9.34961 8.32324C9.67554 8.77955 9.69627 9.38273 9.41113 9.85742L9.34961 9.95117L8.79688 10.7246C8.4294 11.2391 8.34774 11.8851 8.66406 12.4297L8.73242 12.5371C9.11961 13.0919 9.65614 13.7855 10.1357 14.3018L10.3369 14.5107C10.7304 14.9043 11.2873 15.3615 11.8086 15.752L12.3105 16.1152C12.8406 16.4851 13.4877 16.4499 14.0186 16.1211L14.123 16.0508L14.8975 15.498C15.3537 15.1722 15.957 15.1514 16.4316 15.4365L16.5244 15.498L19.1621 17.3818C19.8658 17.8847 19.9495 18.8991 19.3379 19.5107L18.749 20.0996C17.4807 21.368 15.7999 22.1183 14.1602 21.5615L14.001 21.5029C12.2234 20.8054 9.9176 19.4654 7.65039 17.1982C5.52478 15.0726 4.21369 12.9129 3.4834 11.1865L3.34473 10.8467C2.72341 9.26275 3.35013 7.62678 4.50977 6.34961L4.74805 6.09863L5.33691 5.50977Z"
        :stroke="`url(#${componentId}_paint2_linear_3136_637)`"
        stroke-opacity="0.1"
        stroke-width="0.2"
      />
    </g>
    <foreignObject
      x="8"
      y="4.07104"
      width="11.9293"
      height="11.9294"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(1.5px); clip-path: url(#${componentId}_bgblur_1_3136_637_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <g :filter="`url(#${componentId}_filter1_i_3136_637)`" data-figma-bg-blur-radius="3">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 13.0005C15.4477 13.0005 15.0128 12.5458 14.8766 12.0106C14.5167 10.5968 13.4037 9.48384 11.9899 9.12392C11.4547 8.98766 11 8.55277 11 8.00049C11 7.4482 11.4511 6.99175 11.9958 7.08275C14.5117 7.503 16.4975 9.48879 16.9177 12.0047C17.0087 12.5494 16.5523 13.0005 16 13.0005Z"
        fill="#F1F1F1"
        fill-opacity="0.05"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 13.0005C15.4477 13.0005 15.0128 12.5458 14.8766 12.0106C14.5167 10.5968 13.4037 9.48384 11.9899 9.12392C11.4547 8.98766 11 8.55277 11 8.00049C11 7.4482 11.4511 6.99175 11.9958 7.08275C14.5117 7.503 16.4975 9.48879 16.9177 12.0047C17.0087 12.5494 16.5523 13.0005 16 13.0005Z"
        :fill="`url(#${componentId}_paint3_linear_3136_637)`"
        fill-opacity="0.4"
      />
      <path
        d="M11.9795 7.18115C14.3758 7.58148 16.2838 9.42669 16.7764 11.7905L16.8193 12.021C16.8983 12.4935 16.5025 12.9009 16 12.9009C15.5688 12.9009 15.2047 12.5876 15.0342 12.1704L14.9736 11.9858C14.6277 10.627 13.6032 9.53954 12.2822 9.10498L12.0146 9.02686C11.5088 8.89807 11.0996 8.49323 11.0996 8.00049C11.0996 7.52938 11.4576 7.15262 11.8916 7.17236L11.9795 7.18115Z"
        :stroke="`url(#${componentId}_paint4_linear_3136_637)`"
        stroke-opacity="0.1"
        stroke-width="0.2"
      />
    </g>
    <foreignObject
      x="8.00098"
      y="0.0446777"
      width="15.9552"
      height="15.9553"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(1.5px); clip-path: url(#${componentId}_bgblur_2_3136_637_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <g :filter="`url(#${componentId}_filter2_i_3136_637)`" data-figma-bg-blur-radius="3">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.001 13C19.4487 13 19.0075 12.55 18.9393 12.002C18.4888 8.38167 15.6193 5.51217 11.999 5.06165C11.4509 4.99344 11.001 4.55228 11.001 4C11.001 3.44772 11.45 2.99475 11.9996 3.04924C16.7251 3.51775 20.4832 7.27586 20.9517 12.0014C21.0062 12.551 20.5533 13 20.001 13Z"
        fill="#F1F1F1"
        fill-opacity="0.05"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.001 13C19.4487 13 19.0075 12.55 18.9393 12.002C18.4888 8.38167 15.6193 5.51217 11.999 5.06165C11.4509 4.99344 11.001 4.55228 11.001 4C11.001 3.44772 11.45 2.99475 11.9996 3.04924C16.7251 3.51775 20.4832 7.27586 20.9517 12.0014C21.0062 12.551 20.5533 13 20.001 13Z"
        :fill="`url(#${componentId}_paint5_linear_3136_637)`"
        fill-opacity="0.4"
      />
      <path
        d="M11.9893 3.14844C16.521 3.59774 20.1543 7.10363 20.7988 11.5752L20.8525 12.0117C20.9002 12.4956 20.5008 12.9004 20.001 12.9004C19.5375 12.9004 19.1528 12.5443 19.0547 12.083L19.0381 11.9893C18.596 8.43822 15.856 5.60124 12.3525 5.0127L12.0117 4.96289C11.5059 4.89994 11.1006 4.49432 11.1006 4C11.1006 3.53108 11.4568 3.15042 11.9004 3.14453L11.9893 3.14844Z"
        :stroke="`url(#${componentId}_paint6_linear_3136_637)`"
        stroke-opacity="0.1"
        stroke-width="0.2"
      />
    </g>
    <defs>
      <filter
        :id="`${componentId}_filter0_i_3136_637`"
        x="0"
        y="2"
        width="22.8481"
        height="22.8481"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3136_637" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_0_3136_637_clip_path`" transform="translate(0 -2)">
        <path
          d="M7.57934 17.2688C5.30202 14.9915 3.95412 12.6737 3.2517 10.8835C2.56813 9.14132 3.35431 7.35169 4.67765 6.02834L5.26661 5.43939C5.92203 4.78396 7.00912 4.87393 7.54787 5.62819L9.43146 8.26521C9.80399 8.78676 9.80399 9.48738 9.43146 10.0089L8.87841 10.7832C8.50649 11.3039 8.44839 11.9553 8.81458 12.48C9.25541 13.1117 9.88888 13.9215 10.4078 14.4404C10.9267 14.9593 11.7364 15.5927 12.3681 16.0336C12.8928 16.3997 13.5443 16.3416 14.0649 15.9697L14.8392 15.4167C15.3608 15.0441 16.0614 15.0441 16.5829 15.4167L19.2199 17.3003C19.9742 17.839 20.0642 18.9261 19.4087 19.5815L18.8198 20.1705C17.4964 21.4938 15.7068 22.28 13.9646 21.5964C12.1744 20.894 9.85666 19.5461 7.57934 17.2688Z"
        />
      </clipPath>
      <filter
        :id="`${componentId}_filter1_i_3136_637`"
        x="8"
        y="4.07104"
        width="11.9293"
        height="11.9294"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3136_637" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_1_3136_637_clip_path`" transform="translate(-8 -4.07104)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 13.0005C15.4477 13.0005 15.0128 12.5458 14.8766 12.0106C14.5167 10.5968 13.4037 9.48384 11.9899 9.12392C11.4547 8.98766 11 8.55277 11 8.00049C11 7.4482 11.4511 6.99175 11.9958 7.08275C14.5117 7.503 16.4975 9.48879 16.9177 12.0047C17.0087 12.5494 16.5523 13.0005 16 13.0005Z"
        />
      </clipPath>
      <filter
        :id="`${componentId}_filter2_i_3136_637`"
        x="8.00098"
        y="0.0446777"
        width="15.9552"
        height="15.9553"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3136_637" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_2_3136_637_clip_path`" transform="translate(-8.00098 -0.0446777)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.001 13C19.4487 13 19.0075 12.55 18.9393 12.002C18.4888 8.38167 15.6193 5.51217 11.999 5.06165C11.4509 4.99344 11.001 4.55228 11.001 4C11.001 3.44772 11.45 2.99475 11.9996 3.04924C16.7251 3.51775 20.4832 7.27586 20.9517 12.0014C21.0062 12.551 20.5533 13 20.001 13Z"
        />
      </clipPath>
      <linearGradient
        :id="`${componentId}_paint0_linear_3136_637`"
        x1="4"
        y1="20"
        x2="14"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset="0.510667" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_3136_637`"
        x1="3"
        y1="21.8481"
        x2="19.8481"
        y2="21.8481"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset="0.510667" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint2_linear_3136_637`"
        x1="3.5265"
        y1="5.76582"
        x2="19.8481"
        y2="5.76582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADECB8" />
        <stop offset="1" stop-color="#2FAED3" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint3_linear_3136_637`"
        x1="11"
        y1="13.0005"
        x2="17"
        y2="13.0005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset="0.510667" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint4_linear_3136_637`"
        x1="11.1875"
        y1="7.27322"
        x2="17"
        y2="7.27322"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADECB8" />
        <stop offset="1" stop-color="#2FAED3" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint5_linear_3136_637`"
        x1="11.001"
        y1="13"
        x2="21.001"
        y2="13"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset="0.510667" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint6_linear_3136_637`"
        x1="11.3135"
        y1="3.45455"
        x2="21.001"
        y2="3.45455"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADECB8" />
        <stop offset="1" stop-color="#2FAED3" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
